import axios, {axios_Identity, simpleErrorHandling} from "config/network";

const login = async (username, password) => {
    try {
        const response = await axios_Identity.post("/api/Authentication/GetToken", {
            userName: username,
            password,
        });
        const result = response.data;

        return result?.data;
    } catch (err) {
        simpleErrorHandling(err, "Failed to login");
    }
};

const getNewAccessToken = async (refreshToken) => {
    try {
        const response = await axios_Identity.post(
            "/api/Authentication/GetNewAccessToken",
            {refreshToken}
        );
        const {data} = response;
        return data?.data;
    } catch (err) {
        simpleErrorHandling(err, "Failed to get new token please login");
    }
};

const resetPassword = async (body) => {
    try {
        const response = await axios_Identity.post(`/api/Authentication/ChangePassword`, body);
        return response.data;
    } catch (err) {
        simpleErrorHandling(err, "Failed to reset password");
    }
};

const forgotPassword = async (body) => {
    try {
        const response = await axios_Identity.post(`/api/Authentication/ForgotPassword`, body);
        return response.data;
    } catch (err) {
        simpleErrorHandling(err, "Failed to reset password");
    }
};

const ValidateTenants = async (siteId, body) => {
    try {
        let formData = new FormData();
        formData.append("file", body);

        const response = await axios_Identity.post(
            `/api/Tenant/ValidateUploadBulkTenants`,
            formData
        );

        return response;
    } catch (err) {
        simpleErrorHandling(err, "Failed to upload file");
    }
};
const AddTenants = async (siteId, body) => {
    try {
        const response = await axios_Identity.post(
            `/api/Tenant/Site/${siteId}/AddTenants`,
            body
        );
        return true;
    } catch (err) {
        simpleErrorHandling(err, "Failed to upload file");
    }
};
const editTenant = async (body) => {
    try {
        const response = await axios_Identity.patch(`/api/Tenant/EditTenant`, body);
        const {data} = response;
        if (data?.code === 1) {
            return response.data;
        } else {
            throw new Error(data?.message);
        }
    } catch (err) {
        simpleErrorHandling(err, "Failed to edit tenant");
    }
};

const tenantSettings = async (tenantId, allowCommissioning = false) => {
    try {
        const response = await axios.get(
            `/api/TenantSettings/${tenantId}/GetTenantSetting`, {
                params: {
                    allowCommissioning
                }
            }
        );
        const {data} = response.data;

        return data.map(({value, ...data}) => ({
            ...data,
            value:
                typeof value == "boolean"
                    ? value
                        ? "true"
                        : "false"
                    : value === "true" || value === "false"
                        ? value == "true"
                            ? true
                            : false
                        : value,
            isUpdateable: data?.isUpdateable,
        }));
    } catch (err) {
        simpleErrorHandling(err, "Failed to edit Tenant");
    }
};

const tenantSettingsBySettingKey = async (settingKey) => {
    try {
        const response = await axios.get(
            `/api/TenantSettings/${settingKey}`
        );
        const {data} = response.data;

        return data?.value;
    } catch (err) {
        // simpleErrorHandling(err, "Failed to edit Tenant");
    }
};
const UpdateSettings = async (tenantId, body) => {
    try {
        const response = await axios.put(
            `/api/TenantSettings/${tenantId}/UpdateTenantSettings`,
            {
                tenantId,
                Settings: body,
            }
        );
        return response.data;
    } catch (err) {
        simpleErrorHandling(err, "Failed to update settings");
    }
};
// get tenants
const getTenants = async () => {
    try {
        const response = await axios_Identity.get(
            `/api/Tenant/GetTenantsUnderUserManagement`
        );
        const {data} = response.data;
        return data;
    } catch (err) {
        simpleErrorHandling(err, "Failed to get Tenants");
    }
};

const userChooseOrSwitchTenant = async (
    tenantId,
    selectTenantFirstTime = false,
    tempToken
) => {
    try {
        if (selectTenantFirstTime && tempToken) {
            const response = await axios_Identity.post(
                `/api/Authentication/switch-tenant/${tenantId}`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${tempToken}`,
                    },
                }
            );
            const result = response.data;

            return {switchedTenant: result?.data, message: result.message}
        } else {
            const response = await axios_Identity.post(
                `/api/Authentication/switch-tenant/${tenantId}`
            );
            const result = response.data;

            return {switchedTenant: result?.data, message: result.message};
        }
    } catch (err) {
        simpleErrorHandling(err, "Failed to select tenant");
    }
};
export const GeneralService = {
    login,
    editTenant,
    AddTenants,
    resetPassword,
    forgotPassword,
    tenantSettings,
    tenantSettingsBySettingKey,
    UpdateSettings,
    ValidateTenants,
    getTenants,
    getNewAccessToken,
    userChooseOrSwitchTenant,
};
